import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_Signup_Signin',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportalqa.b2clogin.com/tfp/mncportalqa.onmicrosoft.com'
};

export const environment: IEnvironmentVariables = {
  commonDomainEmailNoteReleaseDate: '2025-09-01T00:00:00Z',
  b2cPolicies: b2cPolicies,
  production: true,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: 'https://usermgmt.portalqa.mynexuscare.com/',
  apiUrl: 'https://api-homehealth.portalqa.mynexuscare.com',
  platformApiUrl: 'https://api-platform.portalqa.mynexuscare.com',
  registryUrl: `https://api-platform.portalqa.mynexuscare.com/api/app-registry`,
  authConfig: {
    config: {
      auth: {
        clientId: '386a6be3-ed0d-4bcc-ac0a-178b0d194913',
        postLogoutRedirectUri: 'https://usermgmt.portalqa.mynexuscare.com/login',
        redirectUri: 'https://usermgmt.portalqa.mynexuscare.com/login',
        knownAuthorities: ['mncportalqa.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`,
        navigateToLoginRequestUrl: false,
      },
    },
    angularConfig: {
      consentScopes: [
        'https://mncportalqa.onmicrosoft.com/api/api.Write',
        'https://mncportalqa.onmicrosoft.com/api/api.Read',
        'https://mncportalqa.onmicrosoft.com/api/user_impersonation',
      ],
      protectedResourceMap: [
        [
          'https://api-homehealth.portalqa.mynexuscare.com/',
          [
            'https://mncportalqa.onmicrosoft.com/api/api.Write',
            'https://mncportalqa.onmicrosoft.com/api/api.Read',
            'https://mncportalqa.onmicrosoft.com/api/user_impersonation',
          ]
        ],
        [
          'https://api-platform.portalqa.mynexuscare.com/',
          [
            'https://mncportalqa.onmicrosoft.com/api/api.Write',
            'https://mncportalqa.onmicrosoft.com/api/api.Read',
            'https://mncportalqa.onmicrosoft.com/api/user_impersonation',
          ]
        ]
      ]
    }
  }
};
